import { Table } from "antd";
import React, { useState } from "react";
import TableTitle from "../../../../../../common/TableTitle";
import { SearchHeader } from "../../../../../../layout/header/HeaderList";

const BilanActif = ({ values, valuesN1, mission, loading }) => {
  const [filtersItems, setFiltersItems] = useState(values);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filtered = (values ?? []).filter((item) => {
      const libelle = item?.libelle?.toLowerCase() ?? "";
      const ref = item?.ref?.toLowerCase() ?? "";
      return libelle.includes(searchTerm) || ref.includes(searchTerm);
    });
    setFiltersItems(filtered);
  };

  const columns = [
    {
      title: () => <TableTitle>#</TableTitle>,
      render: (_, record, index) => <>{index + 1}</>,
      width: 40,
    },
    {
      title: () => <TableTitle>Référence</TableTitle>,
      dataIndex: "ref",
      width: 100,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.ref}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Libellé</TableTitle>,
      dataIndex: "libelle",
      width: 400,
      render: (_, record) => (
        <>
          <span className="fw-bolder" style={{ fontSize: "14px" }}>
            {record.libelle}
          </span>
        </>
      ),
      responsive: ["sm"],
    },
    {
      title: () => <TableTitle>Brut</TableTitle>,
      dataIndex: "brut",
      width: 100,
      render: (_, record) => (
        <>
          <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
            {record.brut && record.brut.toLocaleString("fr")}
          </div>
        </>
      ),
    },
    {
      title: () => <TableTitle>Amor et Déprec</TableTitle>,
      dataIndex: "amortissement",
      width: 100,
      render: (_, record) => (
        <>
          <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
            {record.amortissement && record.amortissement.toLocaleString("fr")}
          </div>
        </>
      ),
    },
    {
      title: () => <TableTitle>{`Exercice ${mission.annee} net`}</TableTitle>,
      dataIndex: "exerciceN",
      width: 100,
      render: (_, record) => (
        <>
          <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
            {record.exerciceN && record.exerciceN.toLocaleString("fr")}
          </div>
        </>
      ),
    },
    {
      title: () => (
        <TableTitle>{`Exercice ${parseInt(mission.annee) - 1} net`}</TableTitle>
      ),
      dataIndex: "exerciceN1",
      width: 100,
      render: (_, record, index) => (
        <>
          <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
            {valuesN1[index]?.exerciceN &&
              valuesN1[index].exerciceN.toLocaleString("fr")}
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="table-responsive">
      {(values ?? []).length > 0 && (
        <div className="card-header border-0 pt-2">
          <SearchHeader
            placeholder="Rechercher par la référence et le libellé"
            handleSearch={handleSearchChange}
          />
        </div>
      )}
      <div className="py-4">
        <div className="table-responsive">
          <Table
            rowClassName={(record) =>
              `${
                record.color ? `bg-${record?.color} text-white` : ""
              } h-3px text-hover-gray-800 p-0 m-0 lh-0.5`
            }
            columns={columns}
            rowKey={(record, index) => index}
            dataSource={filtersItems ?? []}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            loading={loading}
            //rowSelection
            size={"small"}
          />
        </div>
      </div>
    </div>
  );
};

export { BilanActif };
